module.exports = __webpack_public_path__ + "static/media/round&victory_tracks.d1757522.png";